export default __webpack_public_path__ + "static/media/orangeMarker.1be66190.svg";